import { configureStore } from '@reduxjs/toolkit'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import type { WidgetConfig } from '../types'
import { configActions, configSlice } from './configSlice'
import { dataActions, dataSlice } from './dataSlice'
import { filterSlice } from './filterSlice'
import { useAppSelector } from './hooks'
export { MapsApiProvider } from '../../../../assets/frontend/js/components/location-map/MapsApiProvider'

export const store = configureStore({
  reducer: {
    [configSlice.name]: configSlice.reducer,
    [dataSlice.name]: dataSlice.reducer,
    [filterSlice.name]: filterSlice.reducer
  }
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

function OnReady({ children }: { children: React.ReactNode }) {
  const ready = useAppSelector((state) => state.config.ready)
  return ready ? <>{children}</> : null
}

export function StoreProvider({
  children,
  config
}: { children: React.ReactNode; config?: WidgetConfig }) {
  useEffect(() => {
    if (config) {
      const { locationTypes, ...rest } = config

      store.dispatch(dataActions.setData({ locationTypes }))
      store.dispatch(configActions.setConfig(rest))
    }
  }, [config])

  return (
    <Provider store={store}>
      <OnReady>{children}</OnReady>
    </Provider>
  )
}
